import { Component, ViewChild } from '@angular/core';
import { CommissionsService } from './commissions.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TableTransactionsComponent } from '../table-transactions/table-transactions.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DatePipe } from '@angular/common';
import { TableTransactionsCommissionsComponent } from '../table-transactions-commissions/table-transactions-commissions.component';

@Component({
  selector: 'app-extrato',
  templateUrl: './commissions.component.html',
  styleUrls: ['./commissions.component.scss'],
})
export class CommissionsComponent {
  totalDeposito: number = 0
  qtDeposito: number = 0
  totalSaque: number = 0
  qtSaque: number = 0
  totalComissao: number = 0

  comissao = new FormGroup({
    tipo: new FormControl<string>(''),
    status: new FormControl<string>(''),
    tipoBusca: new FormControl<string>(''),
    origem: new FormControl<string>(''),
    aplicacao: new FormControl<string>(''),
    responsavel: new FormControl<string>(''),
    initialDate: new FormControl<NgbDateStruct | null>(
      null,
      Validators.required
    ),
    endDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
  });


  public isFilterColapsed = false;
  public isSubmitted = false;
  public isLoaded: boolean = false;
  public transactions: any[] = [];

  @ViewChild(TableTransactionsCommissionsComponent) table!: TableTransactionsCommissionsComponent;

  constructor(
    private commissionService: CommissionsService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    this.comissao.controls.initialDate.setValue({
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    });
    this.comissao.controls.endDate.setValue({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });
    this.comissao.controls.status.setValue('REALIZADO');
    this.comissao.controls.tipoBusca.setValue('personName')
    this.isLoaded = true;
  }


  onTransactionsLoaded(lista: any[]): void {
  this.transactions = lista ?? [];

  const sum = (prop: keyof typeof lista[0]) =>
    this.transactions.reduce(
      (tot, t) => tot + (Number(t[prop]) || 0), 0);

  this.totalDeposito  = sum('valueCashIn');   
  this.qtDeposito     = sum('qtdeCahsIn');    
  this.totalSaque     = sum('valueCashOut');  
  this.qtSaque        = sum('qtdeCahsOut');   
  this.totalComissao  = sum('commission');  

  this.isLoaded = true;
}


  buscar() {
    this.isSubmitted = true;
    this.isLoaded = false;

    let formStartDate = this.comissao.controls.initialDate.value!;
    let formEndDate = this.comissao.controls.endDate.value!;

    let startDate = new Date(
      formStartDate.year,
      formStartDate.month - 1,
      formStartDate.day
    );
    let endDate = new Date(
      formEndDate.year,
      formEndDate.month - 1,
      formEndDate.day
    );

    if (startDate > endDate) {
      this.toastr.error(
        'Data inicial deve ser menor ou igual a data final!',
        'Erro',
        {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        }
      );
      this.isLoaded = true;
      return;
    }

    if (this.comissao.invalid) {
      this.isLoaded = true;
      return;
    }

    this.table.page = 1;

    this.table.dataInitial = this.comissao.controls.initialDate.value!;
    this.table.dataFinal = this.comissao.controls.endDate.value!;
    this.table.personName = this.comissao.controls.responsavel.value!;
    this.table.getTransactions();

    this.isSubmitted = false;
  }

  filterColapse() {
    this.isFilterColapsed = !this.isFilterColapsed;
  }

  downloadFile() {
    let dataInitial = this.comissao.controls.initialDate.value!;
    let dataFinal = this.comissao.controls.endDate.value!;

    let dateInitialFormat = new Date(
      dataInitial.year,
      dataInitial.month - 1,
      dataInitial.day
    );
    let dateFinalFormat = new Date(
      dataFinal.year,
      dataFinal.month - 1,
      dataFinal.day
    );
    this.commissionService
      .getCsvFile(
        dateInitialFormat,
        dateFinalFormat,
        this.comissao.controls.tipo.value!,
        this.comissao.controls.status.value!
      )
      .subscribe((value) => {
        let csvContent = decodeURIComponent(escape(atob(value)));
        const a = document.createElement('a');
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        });
        const url = window.URL.createObjectURL(blob);
        let company = this.authService.getCompany();
        a.href = url;
        a.download = `${company}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }
}
